export default __webpack_public_path__ + "static/media/las-vegas.c65f7ca0.jpg";